'use strict';

// import './f--forms/script';

(function syncHeaderHeight() {
    const desktop = document.querySelector('.b--header');
    const mobile = document.querySelector('.b--mobile-navigation');
    const update = () => {
        const header = desktop?.offsetHeight > 0 ? desktop : mobile;
        if (!header) return;
        document.documentElement.style.setProperty(
            '--header-height',
            header.offsetHeight + 'px'
        );
    };
    update();
    window.addEventListener('resize', update);
})();

